var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 492 385.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.42,115.92a53,53,0,0,0-13.77,14.31,6,6,0,0,0,10,6.55h0a40.84,40.84,0,0,1,10.66-11.07,6,6,0,0,0-6.94-9.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.75,373.21h-44V98.35c0-.1,0-.19,0-.29C55.78,50.61,92.39,12,137.39,12c43.26,0,78.74,35.69,81.42,80.61a52.93,52.93,0,0,0-46.69,52.5v9.37a6,6,0,0,0,6,6h26.7c2.65,9.6,11.22,16.69,21.27,16.69s18.62-7.08,21.27-16.69h24.51a6,6,0,0,0,6-6v-9.37a53,53,0,0,0-47-52.55C228.11,41,187.24,0,137.39,0,86,0,44.07,43.7,43.79,97.52c0,.14,0,.28,0,.42V373.21H6a6,6,0,0,0,0,12H99.75a6,6,0,0,0,0-12Zm126.34-208a10,10,0,0,1-8.29-4.69h16.57A9.92,9.92,0,0,1,226.09,165.17Zm39.78-20.06v3.37H184.12v-3.37a40.88,40.88,0,1,1,81.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.66,280.51v-39.7a25.29,25.29,0,0,0-25.45-25.06H328.42a25.21,25.21,0,0,0-18,7.42c-.5.5-1,1-1.41,1.55a25.52,25.52,0,0,0-19.49-9H179.1a25.29,25.29,0,0,0-25.45,25.06v39.81a29,29,0,0,0-26.46,28.66v69.93a6,6,0,0,0,6,6h46.52a6,6,0,0,0,6-6v-8l247.77.08v7.91a6,6,0,0,0,6,6H486a6,6,0,0,0,6-6V309.27A29,29,0,0,0,463.66,280.51ZM318.92,231.64a13.31,13.31,0,0,1,9.5-3.9H438.21a13.26,13.26,0,0,1,13.45,13.06v41.83a28.85,28.85,0,0,0-18.18,26.64v2.35l-118.48,0V241.4a13.64,13.64,0,0,1,3.91-9.76Zm-139.82-3.9H289.52A13.28,13.28,0,0,1,303,240.81l0,70.78-117.28,0v-2.28A28.87,28.87,0,0,0,165.65,282V240.81a13.28,13.28,0,0,1,13.45-13.07Zm-5.39,145.47H139.19V309.27a17.27,17.27,0,0,1,34.52,0Zm12-14V323.56l123.28,0h0l124.48,0v35.67Zm294.29,14H445.48V309.27a17.27,17.27,0,0,1,34.52,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHall2);
export default __webpack_public_path__ + "static/media/Hall2.b26d2b0288de43f8d1a72be8ab8de288.svg";
export { ForwardRef as ReactComponent };